// Libs
import React from 'react';
import { Typography } from '@mui/material';

// Utils
import { ORDER_APPROVAL_STATUSES } from '../../constants/approvals';

// Styles
import { useStyles } from './ApprovalLabelStyles';

const ApprovalLabel = ({
  orderItemStatus,
  approver,
  isModified,
  align = 'left',
  className,
  ...props
}) => {
  const { WAITING_FOR_APPROVAL, APPROVED, REJECTED } = ORDER_APPROVAL_STATUSES;
  const { classes, cx } = useStyles({ align });

  const getLabelText = (orderItemStatus, approver, isModified) => {
    switch (orderItemStatus) {
      case WAITING_FOR_APPROVAL:
        return 'Pending Approval';
      case REJECTED:
        return `Rejected By ${approver}`;
      case APPROVED:
        return isModified
          ? `Modified And Approved By ${approver}`
          : `Approved By ${approver}`;
    }
  };

  return (
    <Typography
      variant="textSm"
      color={'grey2'}
      className={cx(classes.label, className)}
      {...props}>
      {getLabelText(orderItemStatus, approver, isModified)}
    </Typography>
  );
};

export default ApprovalLabel;
